import React from "react"

// Context
import {useUiSkin} from "../../modules/ui-skin/context/UiSkinContext"

// Theme
import ModernThemeProvider from "../../theme/modern/ModernThemeProvider"

// Components
import Layout from "../Layout"
import ModernShell from "../modern/ModernShell"

/**
 * Chooses the app chrome for the active skin.
 *
 * This is the ONLY place the Modern MUI theme is mounted, which is what
 * guarantees the Classic tree can never resolve `palette.type: "dark"` or a
 * `theme.modern` token object. Classic renders the untouched <Layout/> outside
 * the Modern provider entirely.
 */
export default function LayoutSwitch(props: {children: React.ReactNode}) {
    const {isModern} = useUiSkin();

    if (isModern) {
        return (
          <ModernThemeProvider>
              <ModernShell>
                  {props.children}
              </ModernShell>
          </ModernThemeProvider>
        )
    }

    return (
      <Layout>
          {props.children}
      </Layout>
    )
}
